import { Fragment } from "react";
import styled from "styled-components";

import { Title, SubTitle, Header } from "./atoms/titles";
import { lightGray, white } from "../utils/color";
import logo from "../utils/img/kuf3.png";
import map from "../utils/img/map.png";
import { HeaderLogo, MainImg } from "./atoms/logoImages";

const MapContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	font-family: "Noto Sans KR", sans-serif;
	width: 100%;
	padding: 15px 30px 90px 30px;
	box-sizing: border-box;
	background-color: ${lightGray};
`;

const MapSubContainer = styled.div`
	margin-top: 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Icon = styled.div`
	width: 80px;
	height: 20px;
	border: 1px solid black;
	border-radius: 10px;
	margin: 0 0 10px 0;
	font-size: 13px;
	display: flex;
	justify-content: center;
`;

const ModeUl = styled.ul`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	list-style-type: None;
	padding: 0;
	margin: 0 0 10px 0;
`;

const ModeLi = styled.li`
	font-size: 15px;
	margin-bottom: 10px;
`;

export default function Map() {
	const busList = [
		[
			"서울신문사 하차: ",
			"(간선) 101, 150, 402, 405, 501, 506, N40, (지선) 1711, 7016, (순환) 91S투어",
		],
		[
			"광화문빌딩 하차: ",
			"(간선) 700, 707  (광역) 9703, 9714, M7106, M7111, M7119",
		],
	];
	const subwayList = [
		["(1호선) ", "시청역 4번 출구에서 프레스센터 방향"],
		["(5호선) ", "광화문역 5번 출구에서 프레스센터 방향"],
	];
	return (
		<Fragment>
			<Header>
				<HeaderLogo src={logo} />
			</Header>
			<MapContainer>
				<Title color={white}>오시는 길</Title>
				<SubTitle></SubTitle>
				<SubTitle>|&nbsp; 약&nbsp;&nbsp; &nbsp;&nbsp;도 &nbsp;|</SubTitle>
				<MainImg src={map} />
				<MapSubContainer>
					<SubTitle>|&nbsp; 대&nbsp;중&nbsp;교&nbsp;통 &nbsp;|</SubTitle>
					<Icon>
						<span>버스</span>
					</Icon>
					<ModeUl>
						{busList.map((c, i) => {
							return (
								<ModeLi key={i}>
									<span>
										<strong>{c[0]}</strong>
									</span>
									<span>{c[1]}</span>
								</ModeLi>
							);
						})}
					</ModeUl>
					<Icon>
						<span>지하철</span>
					</Icon>
					<ModeUl>
						{subwayList.map((c, i) => {
							return (
								<ModeLi key={i}>
									<span>
										<strong>{c[0]}</strong>
									</span>
									<span>{c[1]}</span>
								</ModeLi>
							);
						})}
					</ModeUl>
				</MapSubContainer>
			</MapContainer>
		</Fragment>
	);
}
